import { get } from "lodash";

interface SaPageInfo {
  page_id: string;
  page_name: string;
}

interface SaEventInfo {
  element_id: string;
  element_name: string;
}

interface SaPopInfo {
  pop_id: string;
  pop_name: string;
}

interface TrackerSaConfig {
  [key: string]: {
    pageInfo: SaPageInfo;
    pops?: {
      [key in string]: {
        popInfo: SaPopInfo;
        events?: {
          [key in string]: SaEventInfo;
        };
      };
    };
    events?: {
      [key in string]: SaEventInfo;
    };
  };
}

export default function generateGetTrackerSaReportInfoFunc<T extends TrackerSaConfig>(config: T) {
  // 获取埋点信息
  return function getTrackerReportSaInfo({
    page,
    popName,
    eventName,
  }: {
    page: keyof typeof config;
    popName?: string;
    eventName?: string;
  }) {
    const pageConfig = config[page];
    const pageInfo = pageConfig.pageInfo;
    const popConfig = popName ? get(pageConfig, `pops.${popName}`) : undefined;
    const popInfo = popConfig?.popInfo as { pop_id: string; pop_name: string } | undefined;
    const eventInfo = eventName
      ? ((popName ? get(popConfig, `events.${eventName}`) : get(pageConfig, `events.${eventName}`)) as {
          element_id: string;
          element_name: string;
        })
      : undefined;
    return {
      ...pageInfo,
      ...popInfo,
      ...eventInfo,
    };
  };
}
